import React, { Component } from 'react';

export class ScanTote extends Component {
    render() {
        return (
            <div>
                <form action="#">
                    <h1 className='title'>Scan Tote ID or SO</h1>
                    <input autoComplete="off" id="scanTote" autoFocus name="scanTote" value={this.props.userInput} onChange={(event) => this.props.updateInputValue(event.target.value)}></input>
                    <button onClick={this.props.lookupOrder} className='submit'>Submit</button>
                 </form>
            </div>
        );
    }
}